import { Box, Skeleton } from '@mui/material';

const OverviewItemSkeleton = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
    <Skeleton sx={{ width: '3rem', height: '3rem' }} variant="rounded" />
    <Skeleton sx={{ width: '10rem' }} />
  </Box>
);

export const UnitOverviewSkeleton = () => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
    }}
  >
    <Box
      sx={{
        width: '100%',
        borderBottom: `1px solid #E4E4E4`,
        margin: '1rem 0 0 0',
      }}
    />

    {Array.from({ length: 3 }).map((v, i) => (
      <OverviewItemSkeleton key={i} />
    ))}
  </Box>
);

const DeliveryButtonSkeleton = () => (
  <Skeleton
    sx={{ width: '100%', height: '6.2rem', borderRadius: '1rem' }}
    variant="rounded"
  />
);

const DeliveriesSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      my: '3rem',
    }}
  >
    <Box sx={{ width: { xs: '100%', md: '25rem' } }}>
      <Skeleton sx={{ width: '10rem' }} />
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        gap: '1rem',
      }}
    >
      {Array.from({ length: 5 }).map((v, i) => (
        <DeliveryButtonSkeleton key={i} />
      ))}
    </Box>
  </Box>
);

export const DeliverySignOutSkeleton = () => (
  <Box>
    <Box sx={{ marginLeft: { xs: 0, md: '25rem' } }}>
      <Skeleton sx={{ fontSize: '1.8rem', width: '22rem' }} />
    </Box>
    {Array.from({ length: 2 }).map((v, i) => (
      <DeliveriesSkeleton key={i} />
    ))}
  </Box>
);
